import { dialCodes } from "./dial-codes";
import countryIdentificationCatalog from "./identifications";

export const ENVIRONMENT_GLOBAL = {
    languages: ["es", "en"],
    idleConfig: {
        innactivityTime: 1200,
        timerAnswer: 30,
    },
    dialCodes: dialCodes,
    identifications: countryIdentificationCatalog,
    pageSize: 10,
    proxRFC: "CPV810615PP5",
};
